import { render, staticRenderFns } from "./mailReceiverManage.vue?vue&type=template&id=6363008d"
import script from "./mailReceiverManage.vue?vue&type=script&lang=js"
export * from "./mailReceiverManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6363008d')) {
      api.createRecord('6363008d', component.options)
    } else {
      api.reload('6363008d', component.options)
    }
    module.hot.accept("./mailReceiverManage.vue?vue&type=template&id=6363008d", function () {
      api.rerender('6363008d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/mail/mailReceiverManage.vue"
export default component.exports